import React from 'react';

import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import Modal from '../../../_ui/Modal/Modal';
import { Box } from '@material-ui/core';
import Button from '../../../_ui/Button/Button';

export default function ContingentReportStatusModal({ data, close }) {
  const { t } = useTranslation();

  const statusMap = {
    SIGNED: t('pageReport_statusSIGNED'),
    DENIED: t('pageReport_statusDENIED'),
    UNCONFIRMED: t('pageReport_statusUNCONFIRMED')
  };

  return (
    <Modal
      title={t('pageReport_status')}
      open
      onClose={close}
    >
      <DialogContent>
        <Box className="flex items-center mb2">
          <Typography style={{ width: '50%', fontWeight: 600 }}>
            {t('pageReport_status')}:
          </Typography>
          <Typography style={{ width: '50%' }}>
            {statusMap[data.status] || '-'}
          </Typography>
        </Box>

        <Box className="flex items-center mb2">
          <Typography style={{ width: '50%', fontWeight: 600 }}>
            {t('pageReport_statusDate')}:
          </Typography>
          <Typography style={{ width: '50%' }}>
            {data.attendanceSheetConsentDate
              ? moment(data.attendanceSheetConsentDate).format('DD.MM.YYYY HH:mm')
              : '-'}
          </Typography>
        </Box>

        <Box className="flex items-center mb2">
          <Typography style={{ width: '50%', fontWeight: 600 }}>
            {t('pageReport_statusDenialReason')}:
          </Typography>
          <Typography style={{ width: '50%' }}>
            {data.attendanceSheetConsentDenialReason || '-'}
          </Typography>
        </Box>

        <Box className="flex justify-end pt2">
          <Button
            variant="contained"
            color="primary"
            text={t('pageReport_close')}
            onClick={close}
          />
        </Box>
      </DialogContent>
    </Modal>
  );
}
